import SphLabel from './Label.vue';

export { SphLabel };
export default SphLabel;
